import {
  cloneDeep,
  isEqual,
  isNil,
  isObject,
} from 'lodash';

export default {
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    multiple: {
      default: false,
      type: Boolean,
    },
    options: {
      default: () => [],
      type: Array,
      validator: (val) => {
        if (!val?.length) {
          return true;
        }
        const keys = ['key', 'value'];
        return (
          val.every((data) => {
            if (isObject(data)) {
              return keys.some((key) => key in data);
            }
            return true;
          })
          || val.every(
            (data) => typeof data === 'string' || typeof data === 'number',
          )
        );
      },
    },
    placeholder: {
      default: '',
      type: String,
    },
    readonly: {
      default: false,
      type: Boolean,
    },
    showCheckedIcon: {
      default: false,
      type: Boolean,
    },
    value: {
      default: '',
      type: [Array, String, Object, Number],
    },
  },
  data() {
    return {
      selectedItem: {},
      selectedItems: [],
      showOptions: false,
    };
  },
  computed: {
    isObjectOptions() {
      return this.options?.every((data) => isObject(data));
    },
    newOptions() {
      return this.formatOptions(this.options);
    },
  },
  mounted() {
    this.initValue();
  },
  methods: {
    emitValue() {
      if (!this.multiple) {
        const value = isObject(this.value)
          ? this.selectedItem
          : this.selectedItem.value;
        this.$emit('input', value);
        this.$emit('change', value);
        return;
      }
      const items = this.isObjectOptions
        ? this.selectedItems
        : this.selectedItems.map(({ value }) => value);
      this.$emit('input', items);
      this.$emit('change', items);
    },
    formatOptions(options = []) {
      return this.isObjectOptions
        ? options.map((ele, index) => ({
          ...ele,
          key: isNil(ele.key) ? `${index}-${ele.value}` : ele.key,
        }))
        : options?.map((value, index) => ({
          key: `${index}-${value}`,
          value,
        })) || [];
    },
    hasSelected(optionKey) {
      return this.multiple
        ? this.selectedItems.some(({ key }) => key === optionKey)
        : this.selectedItem?.key === optionKey;
    },
    initValue(val = this.value) {
      const datum = cloneDeep(val);
      if (this.multiple) {
        this.selectedItems.splice(0);
        const newDatum = datum?.map(
          (data) => this.newOptions.find((option) => {
            const dataValue = data?.value ?? data;
            return option.value === dataValue;
          }) || data,
        ) || [];
        this.selectedItems.push(...newDatum);
      } else {
        this.selectedItem = this.newOptions.find(({ value }) => {
          const dataValue = datum?.value ?? datum;
          return value === dataValue;
        }) || {};
      }
    },
    onClose() {
      this.toggleOpen(false);
    },
    onSelect(option = {}) {
      if (option.disabled) {
        return;
      }

      if (!this.multiple) {
        this.selectedItem = option;
        this.emitValue();
        this.$emit('select', option);
        this.onClose();
        return;
      }
      const alreadyExists = this.selectedItems.some(
        ({ key }) => key === option.key,
      );
      if (alreadyExists) {
        this.selectedItems = this.selectedItems.filter(
          ({ key }) => key !== option.key,
        );
      } else {
        this.selectedItems.push(option);
      }
      this.emitValue();
    },
    toggleOpen(show) {
      if (this.disabled || this.readonly) {
        this.onClose();
        return;
      }
      this.showOptions = show;
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.initValue();
      }
    },
  },
};
